import { endPointPublic } from './config'
import axios from 'axios'

export default {
  listarEmpresas: (listar) => {
    return axios.post(endPointPublic + 'v1/listaEmpresasAcesso', listar)
  },
  logar: (logar) => {
    return axios.post(endPointPublic + 'v1/login', logar)
  }
}



// WEBPACK FOOTER //
// ./src/services/login.js